import { Vue } from 'vue-facing-decorator';

export default class ConfigureEmailsHelper extends Vue{
  public static HeroImageUrl  = 'https://cdn.ventla.io/appl9999999/0eff1f4e-c2fb-4351-a8a6-74ea5d50c514.png' ;
  public static LogoPosition = 'left';
  public static EmailAccentColor = '#FFFFFF';
  public static EmailTextColor = '#000000';
  public static FontFamily = 'Verdana';
  public static FooterContent = '';
  public static BodyContent = '';
  public static FooterTextColor = '#fff';
  public static CTALinkColor = '#1E3A8A';
  public static RegisterOrEditButtonText = '';
  public static EventAccessButtonText = 'Open event';
  public static InvitePath = '/Admin/Registration/IndexRegistration';
  public static ToasterTimeOut = 3000;
  public static LoaderTimeOut = 1000;
  public static ToasterType = 'success';
  public static ToasterInfoType = 'info';
  public static ModuleName = 'CustomEmailTemplate';
  public static EventWebPageButtonText = 'Click to register';
  public static LogoMaxSize = 2;
  public static LogoMinHeight = 60;
  public static HeroImageMaxHeight = 900;
  public static HeroImageMaxWidth = 1600;
  public static HeroImageWidthRatio = 16;
  public static HeroImageHeightRatio = 9;
  public static HeroImageMaxSize = 5;
  public static DeleteModal = 0;
  public static ApplyModal = 1;
  public static ErrorModal = 2;
  public static MaxSubjectLength = 150;
  public static MaxButtonTitleLength = 40;
  public static MaxTemplateNameLength = 75;
  public static TemplateNameMinLength = 1;
  public static ToastCoolDownMs = 2100;
  public static ToastLastAt = 0;
  public static StoreHelperTimeout = 700;
}
